<template>
  <modal
      id="support-ticket-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Support Ticket')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        method="post"
        enctype="multipart/form-data"
        :data-url='selectedUrl ? selectedUrl : GET_SUPPORT_TICKETS'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <app-form-group-selectable
              type="select"
              :label="$t('category')"
              list-value-field="name"
              :disabled="this.$isAdmin()"
              v-model="formData.category"
              :chooseLabel="$t('category')"
              :error-message="$errorMessage(errors, 'category')"
              :fetch-url="`${SELECTABLE_TICKET_CATEGORY_STATUS}`"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :disabled="this.$isAdmin()"
              :label="$t('title')"
              v-model="formData.title"
              :error-message="$errorMessage(errors, 'title')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="input-area">
            <div class="d-flex flex-column mb-2">
              <label id="upload-label" for="upload">{{ $t('Ticket Image') }}</label>
              <small v-if="!this.$isAdmin()" class="text-muted font-italic">(Recommended size: 370 x 90 px)</small>
            </div>
            <input id="upload"
                   @change="uploadImage"
                   type="file"
                   required
                   v-if="!this.$isAdmin()"
                   name="image"
                   ref="changeProfileImage"
                   class="form-control">
            <img v-else :src="formData.image" :alt="formData.title" style="max-width: 200px;" />
          </div>
        </div>
      </div>
      <div class="row mt-4">

        <div class="col-md-12">
          <app-input
              type="text-editor"
              v-model="formData.description"
              v-if="!loading"
              :disabled="this.$isAdmin()"
              id="description"
              required
              :placeholder="$textAreaPlaceHolder('description')"
              row="5"
              :error-message="$errorMessage(errors, 'custom_content')"
          />
          <span class="text-danger">{{$errorMessage(errors, 'description')}}</span>
        </div>
      </div>
      <div class="row mt-4" v-if="$can('update_ticket')">
        <div class="col-md-12">
          <app-form-group-selectable
              type="select"
              :label="$t('status')"
              list-value-field="name"
              v-model="formData.status"
              :chooseLabel="$t('status')"
              :error-message="$errorMessage(errors, 'status')"
              :fetch-url="`${SELECTABLE_TICKET_STATUS}`"
          />
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  GET_SUPPORT_TICKETS,SELECTABLE_TICKET_CATEGORY_STATUS, SELECTABLE_TICKET_STATUS
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";
import {InputMixin} from "../../../../core/components/input/mixin/InputMixin";
import _ from "lodash";
import {kebabCase} from "../../../../common/Helper/Support/TextHelper";

export default {
  name: "SupportTicketCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins, InputMixin],
  components: {
  },
  props: {
    from: {
      type: String,
      default: 'ticket'
    },
    recommendation: {
      type: String,
      default: ''
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      textEditorHints,
      maps: null,
      imageUploaderBoot: false,
      image: {
        product_image: null
      },
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      formData: {
        title: "",
        description: "",
        image: "",
        category: "",
        status: "",
      },
      GET_SUPPORT_TICKETS,
      SELECTABLE_TICKET_CATEGORY_STATUS,
      SELECTABLE_TICKET_STATUS,
    }
  },
  methods: {
    async uploadImage(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('product_image', file);

      try {
        const response = await axios.post('/admin/shop/product/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.formData.image = response.data.url;
      } catch (error) {
        console.error("There was an error uploading the image", error);
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.image = URL.createObjectURL(file);
        console.log("Image path:", this.formData.image);
      }
    },
    readURL(event) {
      const files = event.target.files;
      console.log(files);
      if (files && files[0]) {

        let formData = new FormData();

        formData.append('product_image', files[0]);
        formData.append('user_id', 14);

        for (let pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]);
        }

        axiosPost(`admin/shop/product/image`, formData).then(response => {
          console.log(response);
          // this.$store.dispatch("getEmployeeDetails", this.employeeId);
          this.$toastr.s(response.data ? response.data.message : '');
        }).catch(error => {
          console.log(error.response.data);
          // this.$store.dispatch("getEmployeeDetails", this.employeeId);
          this.$toastr.e(error.response.data ? error.response.data.errors.product_image[0] : '');
        });

      }
    },
    propsFor() {
      let props = this.$attrs;
      const cTor = this.$options.components['app-input']
      if (cTor) {
        let keys = Object.keys(cTor.options.props)
        return _.pick(props, keys.map(key => {
          return kebabCase(key)
        }))
      }
    },
    submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      this.isModalActive = false;
      // console.log(this.formData);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#support-ticket-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'ticket' ? 'ticket-table' : 'user-table');
      if (this.from === 'ticket') {
        this.$hub.$emit(`reload-ticket-table`)
      }
    },
    async fetchEditData() {
      this.preloader = true;
      try {
        const response = await axios.get(this.selectedUrl); // Ensure `axios` is configured correctly
        this.afterSuccessFromGetEditData(response);
      } catch (error) {
        console.error("Error fetching edit data:", error);
        this.preloader = false;
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      this.formData = data;
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
  },
  computed: {
    fileLabel() {
      if (this.value && this.fieldValue && this.fieldValue === this.value)
        return this.value?.name ? this.value.name : this.data.label;
      else return this.data.label;
    }
  },
  mounted() {
  },
  watch: {
    isModalActive(newVal) {
      if (newVal) {
        this.fetchEditData();
      }
    },
  },
}
</script>